/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CalculatorIcon16Light } from './CalculatorIcon16Light';
import { CalculatorIcon16Regular } from './CalculatorIcon16Regular';
import { CalculatorIcon16Solid } from './CalculatorIcon16Solid';
import { CalculatorIcon20Light } from './CalculatorIcon20Light';
import { CalculatorIcon20Regular } from './CalculatorIcon20Regular';
import { CalculatorIcon20Solid } from './CalculatorIcon20Solid';
import { CalculatorIcon24Regular } from './CalculatorIcon24Regular';
import { CalculatorIcon24Solid } from './CalculatorIcon24Solid';
import { CalculatorIcon32Regular } from './CalculatorIcon32Regular';
import { CalculatorIcon64Regular } from './CalculatorIcon64Regular';
var sizes = {
    16: {
        light: CalculatorIcon16Light,
        regular: CalculatorIcon16Regular,
        solid: CalculatorIcon16Solid,
    },
    20: {
        light: CalculatorIcon20Light,
        regular: CalculatorIcon20Regular,
        solid: CalculatorIcon20Solid,
    },
    24: {
        regular: CalculatorIcon24Regular,
        solid: CalculatorIcon24Solid,
    },
    32: {
        regular: CalculatorIcon32Regular,
    },
    64: {
        regular: CalculatorIcon64Regular,
    },
};
export var CalculatorIcon = forwardRef('CalculatorIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
